import { Component, Inject, OnInit } from '@angular/core';
import { MeasureService } from '../measure.service';
import { map, switchMap } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-modal-check-informant',
  templateUrl: './modal-check-informant.component.html',
  styleUrls: ['./modal-check-informant.component.scss']
})
export class ModalCheckInformantComponent implements OnInit {
  modalData: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalCheckInformantComponent>,
    private measureService: MeasureService,
    private fb: FormBuilder,
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
  }

  changeInformant() {
    const response = {
      status: true,
    }

    this.dialogRef.close(response);
  }

}
